<template>
    <div>
        <b-row class="mb-2">
            <b-col md="6">
                <h4>Steps</h4>
            </b-col>

            <b-col md="6" class="text-right">
                <b-button-group id="single-page-select">
                    <b-form-radio id="single-page" v-model="currentPortal.singlePage" value="false" button
                                  button-variant="outline-primary">
                        <b-icon icon="files" aria-label="Multiple pages"></b-icon>
                    </b-form-radio>
                    <b-form-radio id="multiple-page" v-model="currentPortal.singlePage" value="true" button
                                  button-variant="outline-primary">
                        <b-icon icon="file" aria-label="Single page"></b-icon>
                    </b-form-radio>
                </b-button-group>
                <b-popover target="single-page-select" triggers="hover" placement="top">
                    Multiple steps display (Default) or Single page display
                </b-popover>
            </b-col>
        </b-row>

        <b-table-simple small borderless responsive fixed class="no-padding">
            <b-thead>
                <b-tr>
                    <b-th key="show_details" class="text-center align-middle col-icon"></b-th>
                    <b-th key="position" class="text-center align-middle col-icon"></b-th>
                    <b-th key="name" class="required">
                        <div>Name</div>
                    </b-th>
                    <b-th key="type" class="required">
                        <div>Type</div>
                    </b-th>
                    <b-th key="edit" class="text-center align-middle col-icon">
                        <b-link @click="addStep" class="h4 text-primary">
                            <b-icon icon="plus-circle"></b-icon>
                        </b-link>
                    </b-th>
                    <b-th key="edit-more" class="text-center align-middle col-icon">
                    </b-th>
                </b-tr>
            </b-thead>
            <draggable :list="steps" tag="tbody" @end="changePosition" ghost-class="ghost" handle=".handle-step">
                <b-tr v-for="step in steps" :key="step.position" class="grab">
                    <b-td colspan="6">
                        <b-table-simple small borderless responsive fixed class="m-0">
                            <b-tr>
                                <b-td class="text-center align-middle col-icon handle-step">
                                    <b-link v-b-toggle="getStepId(step.position,'collapse-details')"
                                            class="text-secondary" size="sm">
                                        <b-icon class="when-opened" icon="chevron-down"></b-icon>
                                        <b-icon class="when-closed" icon="chevron-right"></b-icon>
                                    </b-link>
                                </b-td>
                                <b-td class="text-center align-middle col-icon handle-step">
                                    <b-badge pill variant="primary">{{ step.position }}</b-badge>
                                </b-td>
                                <b-td>
                                    <b-form-input :id="getStepId(step.position,'name')"
                                                  :name="getStepId(step.position,'name')"
                                                  v-model="step.name"/>
                                </b-td>
                                <b-td>
                                    <b-form-select :id="getStepId(step.position,'type')"
                                                   :name="getStepId(step.position,'type')"
                                                   v-model="step.type" :options="stepTypes"
                                                   required></b-form-select>
                                </b-td>
                                <b-td class="text-center align-middle col-icon">
                                    <b-link @click="removeStep(step.position)" class="h4 text-danger"
                                            v-if="steps.length > 1">
                                        <b-icon icon="x-circle"></b-icon>
                                    </b-link>
                                </b-td>
                                <b-td class="text-center align-middle col-icon">
                                    <b-link :id="getStepId(step.position,'more')" class="h4 text-secondary">
                                        <b-icon icon="three-dots-vertical"></b-icon>
                                    </b-link>
                                    <b-popover :target="getStepId(step.position,'more')"
                                               placement="bottomleft" custom-class="popover-dd" triggers="click blur">
                                        <b-list-group>
                                            <b-list-group-item button @click="duplicateStep(step)">
                                                <b-icon icon="files" font-scale="1.5" class="mr-2"></b-icon>
                                                Duplicate
                                            </b-list-group-item>
                                            <b-list-group-item button @click="copyToClipboard(step)">
                                                <b-iconstack font-scale="1.5" class="mr-2">
                                                    <b-icon stacked icon="file-earmark" shift-h="-2"
                                                            shift-v="2"></b-icon>
                                                    <b-icon stacked icon="file-earmark-text-fill" shift-h="2"
                                                            shift-v="-2"></b-icon>
                                                </b-iconstack>
                                                Copy to clipboard
                                            </b-list-group-item>
                                            <b-list-group-item button @click="pasteFromClipboard(step)">
                                                <b-icon icon="clipboard" font-scale="1.5" class="mr-2"></b-icon>
                                                Paste from clipboard
                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-popover>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td colspan="6" style="padding: 0;">
                                    <b-collapse :id="getStepId(step.position,'collapse-details')"
                                                @show="setDetailsVisible(step.position, true)" @hidden="setDetailsVisible(step.position, false)">
                                        <b-card bg-variant="light" v-if="getDetailsVisible(step.position)">
                                            <b-form-row v-if="step.type === 'SUBMITTER' || step.type === 'CONTACT'">
                                                <b-col md="6" v-if="!currentPortal.leadSpace">
                                                    <b-form-group label="Contact Role Classname"
                                                                  label-for="contactRoleClassName">
                                                        <b-form-select
                                                            :id="getStepId(step.position,'contactRoleClassName')"
                                                            :name="getStepId(step.position,'contactRoleClassName')"
                                                            v-model="step.contactRoleClassName"
                                                            :options="contactRoleClassNames"/>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col md="6" v-if="!currentPortal.leadSpace">
                                                    <b-form-group label="Contact Role type" label-for="contactRoleType">
                                                        <b-form-input :id="getStepId(step.position,'contactRoleType')"
                                                                      :name="getStepId(step.position,'contactRoleType')"
                                                                      v-model="step.contactRoleType"/>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col md="6" v-if="currentPortal.leadSpace">
                                                    <b-form-group label="Contact Role" label-for="contactRole">
                                                        <b-input-group>
                                                            <b-form-select v-if="LSContactRoles"
                                                                :id="getStepId(step.position,'contactRole')"
                                                                :name="getStepId(step.position,'contactRole')"
                                                                v-model="step.contactRoleType">
                                                                <b-form-select-option :value="null"></b-form-select-option>
                                                                <b-form-select-option v-for="role in LSContactRoles"
                                                                                      :key="role.value"
                                                                                      :value="role.value">
                                                                    {{ role.label }}
                                                                </b-form-select-option>
                                                            </b-form-select>
                                                            <b-form-input v-if="!LSContactRoles"
                                                                :id="getStepId(step.position,'contactRole')"
                                                                :name="getStepId(step.position,'contactRole')"
                                                                v-model="step.contactRoleType" disabled required/>
                                                            <b-input-group-append is-text>
                                                                <b-link @click="getLSContactRoles" class="text-primary"
                                                                        v-b-tooltip.hover>
                                                                    <b-icon icon="cloud-download"></b-icon>
                                                                </b-link>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-form-row>
                                            <b-form-group label="Description" label-for="description">
                                                <ace-editor :id="getStepId(step.position,'description')"
                                                            :name="getStepId(step.position,'description')"
                                                            v-model="step.description"
                                                            @init="editorInit" :options="editorOptions" lang="html"
                                                            theme="chrome"
                                                            width="100%"></ace-editor>
                                            </b-form-group>
                                            <b-form-group>
                                                <label :for="getStepId(step.position,'condition')">Display condition
                                                    <b-link :id="getStepId(step.position,'condition-help')">
                                                        <b-icon icon="question-circle" variant="primary"></b-icon>
                                                    </b-link>
                                                    <b-popover :target="getStepId(step.position,'condition-help')"
                                                               triggers="focus" placement="top">
                                                        <i>[Step position]</i><b class="text-primary">.</b><i>[Field
                                                        name]</i><b class="text-primary">=</b><i>[value]</i><br>
                                                        Each <b>AND</b> condition separated by ','
                                                    </b-popover>
                                                </label>
                                                <b-form-input :id="getStepId(step.position,'condition')"
                                                              :name="getStepId(step.position,'condition')"
                                                              v-model="step.condition"/>
                                            </b-form-group>

                                            <h5>Fields</h5>
                                            <fields :step="step" :step-index="step.position"
                                                    :fields="step.fields"
                                                    :currentPortal="currentPortal"
                                                    :infoGroups="infoGroups"/>
                                        </b-card>
                                    </b-collapse>
                                </b-td>
                            </b-tr>
                        </b-table-simple>
                    </b-td>
                </b-tr>
            </draggable>
        </b-table-simple>

        <!-- Step import configuration -->
        <b-modal id="modal-import-step" title="Import step configuration" size="lg" @ok="importStep"
                 ok-title="Import" :ok-disabled="importStepModal.loading" :cancel-disabled="importStepModal.loading">
            <b-overlay :show="importStepModal.loading">
                <b-form-textarea id="import-step-content" placeholder="Paste step configuration here" rows="8"
                                 v-model="importStepModal.stepContent"></b-form-textarea>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
    import _ from "lodash";
    import StringUtils from "@/services/utils/StringUtils";
    import EditorUtils from "@/services/utils/EditorUtils";
    import Fields from "@/components/configuration/portal/PortalFields";
    import draggable from "vuedraggable";
    import PortalUtils from "@/services/utils/PortalUtils";
    import LeadSpaceDataService from "@/services/LeadSpaceDataService";

    export default {
        name: "PortalSteps",
        mixins: [StringUtils, EditorUtils, PortalUtils],
        components: {
            Fields,
            draggable
        },
        props: {
            steps: Array,
            currentPortal: Object,
            infoGroups: Array
        },
        data() {
            return {
                // Values
                stepTypes: [
                    {value: 'SUBMITTER', text: 'Submitter'},
                    {value: 'CONTACT', text: 'Additional contact'},
                    {value: 'SUBMISSION', text: 'Submission'},
                    {value: 'SUMMARY', text: 'Summary'},
                ],
                importStepModal: {
                    loading: false,
                    stepIndex: null,
                    stepContent: '',
                },
                contactRoleClassNames: [
                    {value: null, text: ''},
                    {
                        value: 'SubmissionContactRole',
                        text: 'SubmissionContactRole (SubmissionRole)'},
                    {
                        value: 'InternalDevelopmentProjectContactRole',
                        text: 'InternalDevelopmentProjectContactRole (InternalDevelopmentProjectRole)'
                    },
                    {
                        value: 'InLicensingProjectContactRole',
                        text: 'InLicensingProjectContactRole (InLicensingProjectRole)'
                    },
                    {
                        value: 'AgreementContactRole',
                        text: 'AgreementContactRole (AgreementRole)'
                    },
                ],
                LSContactRoles: null,
                detailsVisible: []
            }
        },
        mounted() {
            this.initDetailsVisible();
        },
        methods: {
            initDetailsVisible() {
                this.steps.forEach((step) => {
                    this.detailsVisible[step.position] = false;
                });
            },
            setDetailsVisible(position, value) {
                this.detailsVisible.splice(position, 1, value);
            },
            getDetailsVisible(position) {
                return this.detailsVisible[position] ? this.detailsVisible[position] : false;
            },
            changePosition: function () {
                this.steps.forEach((step, index) => {
                    step.position = index;
                });
            },
            getStepId(index, attribute) {
                return 'step' + index + '-' + attribute;
            },
            getFieldId(stepIndex, index, attribute) {
                return 'step' + stepIndex + '-field' + index + '-' + attribute;
            },
            getFieldValueId(index, attribute) {
                return 'Value' + index + '-' + attribute;
            },
            addStep() {
                let lastPos = (this.steps.length > 0) ? _.maxBy(this.steps, 'position').position : -1;
                this.steps.push({position: lastPos + 1, fields: []});
            },
            removeStep(position) {
                const index = this.steps.findIndex(item => item.position === position);
                this.steps.splice(index, 1)
            },
            duplicateStep(step) {
                let lastPos = (this.steps.length > 0) ? _.maxBy(this.steps, 'position').position : -1;
                let newStep = this.cloneDuplicateStep(step);
                newStep.position = lastPos + 1;
                this.steps.push(newStep);
            },
            copyToClipboard(step) {
                let newStep = this.cloneDuplicateStep(step);
                this.$copyText(JSON.stringify(newStep)).then(() => {
                    this.$bvToast.toast(`Step "${step.name}" configuration copied to clipboard.`, {
                        title: 'Step copied to clipboard',
                        variant: 'primary',
                        toaster: 'b-toaster-bottom-left',
                        solid: true,
                        appendToast: false
                    })
                }, function (e) {
                    this.$bvToast.toast(e, {
                        title: 'Could not copy step configuration to clipboard.',
                        variant: 'danger',
                        toaster: 'b-toaster-bottom-left',
                        solid: true,
                        appendToast: false
                    })
                })
            },
            pasteFromClipboard(step) {
                const index = this.steps.findIndex(item => item.position === step.position);
                this.importStepModal.stepIndex = index;
                this.importStepModal.stepContent = '';
                this.importStepModal.loading = false;
                this.$root.$emit('bv::show::modal', 'modal-import-step');
            },
            importStep(event) {
                event.preventDefault();
                this.importStepModal.loading = true;
                let newStep = JSON.parse(this.importStepModal.stepContent);
                newStep.position = this.steps[this.importStepModal.stepIndex].position;
                this.steps[this.importStepModal.stepIndex] = newStep;
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-import-step')
                    this.importStepModal.loading = false;
                    this.$bvToast.toast(`Step "${newStep.name}" configuration successfully imported from clipboard.`, {
                        title: 'Step imported',
                        variant: 'primary',
                        toaster: 'b-toaster-bottom-left',
                        solid: true,
                        appendToast: false
                    })
                })
            },
            getLSContactRoles() {
                LeadSpaceDataService.getFieldValues(this.currentPortal.client.id, this.currentPortal.client.name, "sw:contactRole")
                    .then(response => {
                        this.LSContactRoles = response.data;
                    })
                    .catch(error => console.log(error))
            },
        },
    }
</script>

<style lang="scss">
    .b-table-sticky-header {
        max-height: 600px;
    }

    .table-head-light {
        .table.b-table > thead > tr > .table-b-table-default,
        .table.b-table > tbody > tr > .table-b-table-default,
        .table.b-table > tfoot > tr > .table-b-table-default {
            background-color: var(--light);
        }
    }

    thead > tr > th {
        vertical-align: middle !important;
    }
</style>